/* eslint-disable max-classes-per-file */
import { BaseError } from './BaseError'

const API_ERROR_TYPE = [
  'BadRequest',
  'Unauthorized',
  'Validation',
  'NotFound',
  'InternalServerError',
  'ServiceUnavailable',
  'Forbidden',
] as const

export type ApiErrorType = (typeof API_ERROR_TYPE)[number]

type ErrorMessage = {
  [key in ApiErrorType]?: string
}

export const DEFAULT_MESSAGE = 'An error occurred'

const messages: ErrorMessage = {
  BadRequest: 'Bad request',
  Unauthorized: 'Insufficient permissions',
}

const ERROR_CODES: { [key in ApiErrorType]: number } = {
  BadRequest: 400,
  Unauthorized: 401,
  InternalServerError: 500,
  ServiceUnavailable: 503,
  Forbidden: 403,
  Validation: 400,
  NotFound: 404,
}

export type ApiErrorMeta = {
  details?: Record<string, any>
  message?: string
  code?: number
}

type ErrorParams = {
  code?: number
  type: ApiErrorType
  cause?: Error
  meta?: ApiErrorMeta
}

function compileError(params: ErrorParams): Error {
  let cause: Error = new Error(DEFAULT_MESSAGE)
  if (params.type) cause = new Error(messages[params.type])
  if (params.cause) cause = params.cause

  return cause
}
export class ApiError extends BaseError {
  readonly type: ApiErrorType

  readonly code: number

  readonly meta?: ApiErrorMeta

  constructor(params: ErrorParams) {
    super(compileError(params))
    this.type = params.type
    this.meta = params.meta
    this.code = ERROR_CODES[params.type]
  }
}
